module.exports = __webpack_public_path__ + "img/image6.e89b0a95.png";